import { render, staticRenderFns } from "./AccionCorrectivaRenderer.vue?vue&type=template&id=6e4ab922&scoped=true&"
import script from "./AccionCorrectivaRenderer.vue?vue&type=script&lang=js&"
export * from "./AccionCorrectivaRenderer.vue?vue&type=script&lang=js&"
import style0 from "./AccionCorrectivaRenderer.vue?vue&type=style&index=0&id=6e4ab922&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4ab922",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
